import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaforpunetogoa() {

const cardData = {
keyword: "Urbania for Pune to Goa Tour Package",
headingDescription: "Urbania for Pune to Goa Tour Package is a convenient group travel option for families, friends, corporate teams, and organized tour groups planning a road trip from Pune to Goa. Ruturaj Enterprises provides spacious Urbania options including 13-seater, 14-seater, 17-seater, and 20-seater vehicles for one-way travel, round trips, multi-day holidays, and customized Goa tour itineraries. With professional driver assistance and flexible travel arrangements, groups can plan their journey around their preferred Pune pickup point, Goa destination, sightseeing schedule, hotel stay, and return date.",
topPlaces: [
{
title: "Calangute Beach",
description: "Calangute Beach is one of Goa's popular coastal destinations and a common stop for visitors planning a beach holiday. Groups travelling from Pune can include Calangute in their Urbania itinerary while exploring nearby beaches, markets, restaurants, and other North Goa attractions."
},
{
title: "Baga Beach",
description: "Baga Beach is a well-known North Goa destination surrounded by restaurants, entertainment options, and nearby tourist attractions. A spacious Urbania is useful for families and groups travelling together from Pune and planning multiple sightseeing stops around the Baga area."
},
{
title: "Candolim Beach",
description: "Candolim Beach offers a popular coastal setting with hotels, restaurants, and convenient access to other North Goa attractions. Pune groups hiring an Urbania can include Candolim in their holiday schedule along with nearby beaches and sightseeing destinations."
},
{
title: "Anjuna Beach",
description: "Anjuna Beach is a popular destination in North Goa known for its coastal scenery and surrounding tourist attractions. Groups travelling from Pune can plan Anjuna as part of a broader Goa sightseeing itinerary while using one Urbania for convenient group transportation."
},
{
title: "Panaji",
description: "Panaji is Goa's capital city and an important base for exploring central Goa, with attractions, markets, churches, hotels, and riverside areas. Urbania transportation allows Pune families and tour groups to travel together while including Panaji in their planned itinerary."
},
{
title: "Dona Paula",
description: "Dona Paula is a scenic destination near Panaji known for its waterfront setting and views. It can be included in a Pune to Goa group tour itinerary along with Panaji and nearby attractions, making a dedicated Urbania useful for coordinated sightseeing."
},
{
title: "Old Goa",
description: "Old Goa is an important historical and heritage area featuring several notable churches and architectural landmarks. Groups travelling from Pune can include Old Goa in their sightseeing plan and use an Urbania for convenient transportation between heritage sites and other destinations."
},
{
title: "Colva Beach",
description: "Colva Beach is a popular South Goa destination with a long coastline and nearby hospitality facilities. Families and groups travelling from Pune can plan Colva as part of a South Goa itinerary using an Urbania for beach visits, sightseeing, hotel transfers, and return travel."
},
{
title: "Palolem Beach",
description: "Palolem Beach is a scenic South Goa destination known for its coastal landscape and relaxed holiday atmosphere. An Urbania is suitable for larger groups planning to travel from Pune to South Goa and cover Palolem along with other attractions."
},
{
title: "Dudhsagar Waterfalls",
description: "Dudhsagar Waterfalls is a well-known natural attraction in the Goa region and is often included in longer sightseeing itineraries. Groups travelling from Pune can coordinate their overall Goa trip with an Urbania while planning the waterfall visit according to local access and activity arrangements."
}
],
services: [
{
name: "Pune to Goa Urbania on Rent",
description: "Pune to Goa Urbania on Rent provides spacious group transportation for families, friends, corporate teams, and organized tour groups travelling to Goa. It can be arranged for one-way journeys, round trips, multi-day holidays, and customized sightseeing itineraries."
},
{
name: "Pune to Goa Urbania Hire",
description: "Pune to Goa Urbania Hire is suitable for groups looking for a dedicated vehicle for their Goa road trip. Customers can plan transportation according to their passenger count, Pune pickup location, Goa destination, sightseeing requirements, travel dates, and return schedule."
},
{
name: "Pune to Goa Urbania Booking",
description: "Pune to Goa Urbania Booking allows travellers to organize their group transportation in advance for planned Goa holidays. Booking arrangements can be discussed around the number of passengers, vehicle capacity, travel duration, hotel locations, sightseeing plans, and return journey."
},
{
name: "Urbania Traveller Pune to Goa",
description: "Urbania Traveller Pune to Goa is a practical option for families and groups travelling together on a long-distance road trip. It can be arranged for beach holidays, family vacations, friend groups, corporate outings, sightseeing tours, and multi-day Goa travel."
},
{
name: "Urbania Van Pune to Goa",
description: "Urbania Van Pune to Goa provides spacious group transportation for customers travelling from Pune toward Goa. It can be used for one-way travel, return journeys, multi-day tours, hotel transfers, sightseeing, and group holiday itineraries."
},
{
name: "13 Seater Urbania Pune to Goa",
description: "13 Seater Urbania Pune to Goa is suitable for smaller and medium-sized groups planning a shared road trip to Goa. It can be arranged for family holidays, friends' trips, sightseeing tours, corporate travel, and round-trip journeys."
},
{
name: "14 Seater Urbania Pune to Goa",
description: "14 Seater Urbania Pune to Goa provides a convenient group travel option for customers who need additional seating capacity for their Goa holiday. It can support family tours, friend groups, corporate outings, sightseeing programs, and multi-day travel."
},
{
name: "17 Seater Urbania Pune to Goa",
description: "17 Seater Urbania Pune to Goa is suitable for larger families, corporate teams, friends, and organized tour groups. The vehicle can be used for a complete Goa itinerary covering the journey from Pune, local sightseeing, hotel transfers, and return travel."
},
{
name: "20 Seater Urbania Pune to Goa",
description: "20 Seater Urbania Pune to Goa is designed for larger groups looking to travel together on a planned Goa tour. It can be arranged for family holidays, group tours, corporate outings, events, multi-day sightseeing, and round-trip journeys."
},
{
name: "Luxury Urbania Pune to Goa",
description: "Luxury Urbania Pune to Goa provides a premium group travel option for customers seeking a more comfortable road-trip experience. It can be considered for family vacations, corporate travel, special occasions, friend groups, and longer multi-day Goa itineraries."
},
{
name: "Urbania for Goa Trip from Pune",
description: "Urbania for Goa Trip from Pune is suitable for travellers planning a complete road trip with a dedicated group vehicle. Customers can organize their itinerary around beaches, heritage attractions, sightseeing locations, hotel stays, and other Goa destinations."
},
{
name: "Urbania for Goa Family Tour Pune",
description: "Urbania for Goa Family Tour Pune provides shared transportation for families travelling together from Pune to Goa. It is suitable for parents, children, relatives, and larger family groups planning a comfortable holiday with coordinated sightseeing and return travel."
},
{
name: "Urbania for Goa Group Tour Pune",
description: "Urbania for Goa Group Tour Pune is useful for friends, families, corporate teams, and organized tourist groups. A dedicated vehicle allows the group to travel together from Pune while following a common hotel, sightseeing, and return schedule."
},
{
name: "Urbania Rental Pune to Goa",
description: "Urbania Rental Pune to Goa provides a dedicated group transportation solution for customers planning an intercity Goa journey. Rental arrangements can be planned according to the vehicle capacity, travel duration, sightseeing requirements, route, and whether the trip is one-way or round trip."
},
{
name: "Urbania Outstation Hire Pune to Goa",
description: "Urbania Outstation Hire Pune to Goa is suitable for groups requiring dedicated transportation for a long-distance holiday. It can be arranged for one-way journeys, return trips, multi-day stays, sightseeing tours, and customized outstation itineraries."
},
{
name: "Urbania Round Trip Pune to Goa",
description: "Urbania Round Trip Pune to Goa is convenient for groups travelling from Pune to Goa and returning after completing their holiday. The journey can be planned around the group's travel dates, hotel stay, sightseeing schedule, pickup point, and preferred return timing."
},
{
name: "Urbania Traveller Rental Pune to Goa",
description: "Urbania Traveller Rental Pune to Goa provides a spacious group vehicle for families, tourists, friends, and corporate teams planning a Goa road trip. It can be used throughout the journey for travel between Pune, Goa hotels, beaches, sightseeing points, and return destinations."
},
{
name: "Pune to Goa Urbania Tour Package",
description: "Pune to Goa Urbania Tour Package is suitable for groups looking to organize their road transportation as part of a planned holiday. The itinerary can include the Pune to Goa journey, local sightseeing, hotel transfers, beach visits, and the return trip according to the group's requirements."
},
{
name: "Pune to Goa Urbania Travel Package",
description: "Pune to Goa Urbania Travel Package provides a group transportation option for customers planning a structured Goa holiday. It can support family tours, friend groups, corporate trips, sightseeing programs, multi-day stays, and return travel between Pune and Goa."
},
{
name: "Affordable Urbania Pune to Goa",
description: "Affordable Urbania Pune to Goa is suitable for groups looking to manage their road-trip transportation costs while travelling together. Pricing can vary according to vehicle capacity, journey duration, total distance, itinerary, sightseeing requirements, and whether the trip is one-way or round trip."
}
],
tableData: [
["Pune to Goa Urbania on Rent"],
["Pune to Goa Urbania Hire"],
["Pune to Goa Urbania Booking"],
["Urbania Traveller Pune to Goa"],
["Urbania Van Pune to Goa"],
["13 Seater Urbania Pune to Goa"],
["14 Seater Urbania Pune to Goa"],
["17 Seater Urbania Pune to Goa"],
["20 Seater Urbania Pune to Goa"],
["Luxury Urbania Pune to Goa"],
["Urbania for Goa Trip from Pune"],
["Urbania for Goa Family Tour Pune"],
["Urbania for Goa Group Tour Pune"],
["Urbania Rental Pune to Goa"],
["Urbania Outstation Hire Pune to Goa"],
["Urbania Round Trip Pune to Goa"],
["Urbania Traveller Rental Pune to Goa"],
["Pune to Goa Urbania Tour Package"],
["Pune to Goa Urbania Travel Package"],
["Affordable Urbania Pune to Goa"]
],
whychoose: [
{
WhyChooseheading: "Spacious Transportation for Goa Road Trips",
WhyChoosedescription: "Ruturaj Enterprises provides Urbania options that allow families, friends, corporate teams, and organized groups to travel together from Pune to Goa. Shared transportation can make a long-distance road trip easier to coordinate while keeping the group together."
},
{
WhyChooseheading: "Different Seating Capacities Available",
WhyChoosedescription: "Goa tour groups can vary in size, so selecting a suitable passenger capacity is important. Customers can consider 13-seater, 14-seater, 17-seater, or 20-seater Urbania options according to their group size, luggage requirements, and travel plans."
},
{
WhyChooseheading: "Suitable for Multi-Day Goa Tours",
WhyChoosedescription: "A Goa holiday may involve several days of travel between the Pune pickup point, hotel, beaches, heritage sites, restaurants, and sightseeing attractions. A dedicated Urbania can support the group throughout a planned multi-day itinerary."
},
{
WhyChooseheading: "Convenient for Family Holidays",
WhyChoosedescription: "Families travelling with children, parents, and relatives can use a shared Urbania for their Pune to Goa journey. Having one vehicle for the group can simplify coordination for beach visits, sightseeing, hotel transfers, and the return journey."
},
{
WhyChooseheading: "Useful for Friends and Group Tours",
WhyChoosedescription: "Friends and organized tour groups can travel together without splitting passengers between several smaller vehicles. Urbania transportation can be planned around the group's common pickup point, Goa accommodation, sightseeing schedule, and return date."
},
{
WhyChooseheading: "Flexible Round-Trip Planning",
WhyChoosedescription: "Customers planning to return to Pune after their Goa holiday can arrange a round-trip journey around their complete itinerary. This is useful for weekend trips, extended vacations, group holidays, and multi-day sightseeing programs."
},
{
WhyChooseheading: "Professional Driver Assistance",
WhyChoosedescription: "Long-distance travel between Pune and Goa involves a substantial road journey, making professional driver assistance useful for groups unfamiliar with the route. Passengers can focus on their holiday while transportation follows the planned route and schedule."
},
{
WhyChooseheading: "Customizable Goa Sightseeing Itinerary",
WhyChoosedescription: "Groups can plan their Goa holiday around North Goa, South Goa, Panaji, heritage locations, beaches, and other attractions according to their available time. A dedicated Urbania provides flexibility for coordinating multiple sightseeing stops during the trip."
}
]
};



















const faqData = [
{
question: "How can I hire an Urbania for a Pune to Goa tour package?",
answer: "Travellers can arrange an Urbania for a Pune to Goa tour by sharing the travel dates, passenger count, Pune pickup location, Goa destinations, number of travel days, and return schedule. Ruturaj Enterprises can plan the group transportation according to the tour itinerary and preferred travel timings."
},
{
question: "Is Urbania suitable for a Pune to Goa group tour?",
answer: "An Urbania can be considered for groups travelling from Pune to Goa when passengers prefer to stay together throughout the journey. It is suitable for family holidays, friends' trips, corporate outings, college groups, and organized tour programs involving multiple days of travel."
},
{
question: "Can I book an Urbania for a Pune to Goa family holiday?",
answer: "Families travelling to Goa from Pune can enquire about an Urbania for a comfortable group transportation arrangement. The itinerary can include Pune pickup, the journey to Goa, hotel transfers, local sightseeing, beach visits, and the return journey based on the family's planned holiday schedule."
},
{
question: "Can Urbania be used for Goa sightseeing during the tour package?",
answer: "An Urbania can be arranged for local Goa sightseeing as part of a Pune to Goa tour package. Groups can include destinations such as Calangute, Baga, Panjim, Candolim, Dona Paula, Old Goa, Vagator, or other locations according to their preferred sightseeing plan and available travel time."
},
{
question: "Can I hire an Urbania for a Pune to Goa friends trip?",
answer: "Friends travelling together can choose an Urbania when planning a group holiday from Pune to Goa. A dedicated vehicle allows the group to coordinate the journey, hotel transfers, sightseeing, beach visits, dining stops, and return travel around a common itinerary."
},
{
question: "Is Urbania available for a multi-day Pune to Goa tour?",
answer: "Multi-day Goa tours can be planned with an Urbania covering the complete travel period. The arrangement may include Pune departure, Goa arrival, local transportation, sightseeing across different areas, hotel movements, nearby attractions, and the return journey to Pune."
},
{
question: "Can companies arrange an Urbania for a Pune to Goa corporate tour?",
answer: "Corporate teams can enquire about an Urbania for employee outings, team-building trips, business retreats, and company tours from Pune to Goa. The passenger count, pickup points, hotel location, activity schedule, sightseeing requirements, and return timing can be shared while planning the transportation."
},
{
question: "Can an Urbania be hired for a Pune to Goa wedding or group event?",
answer: "Wedding parties and social groups can arrange an Urbania for travelling from Pune to Goa for celebrations or organized events. Transportation can be planned around hotel check-ins, event venues, group sightseeing, airport or railway station transfers, and other movements included in the itinerary."
},
{
question: "Does the Pune to Goa Urbania tour package include return travel?",
answer: "A round-trip arrangement can be discussed for groups planning to return from Goa to Pune after completing their tour. Travellers can provide the departure and return dates, hotel stay duration, sightseeing schedule, and preferred timings so the transportation plan covers the complete journey."
},
{
question: "What details are needed to plan an Urbania Pune to Goa tour package?",
answer: "To discuss the tour arrangement, travellers can share the Pune pickup address, travel dates, passenger count, Goa hotel or destination details, number of days, sightseeing preferences, departure time, and return requirements. Ruturaj Enterprises can then understand the itinerary and plan the Urbania rental accordingly."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Rohit Deshmukh",
feedback:
"A group of friends from Pune planned a four-day Goa trip and wanted everyone to travel together instead of arranging separate vehicles. We hired an Urbania from Ruturaj Enterprises and used it for the Pune-Goa journey, hotel transfers, sightseeing, and return trip. It made coordinating the group much easier throughout the tour.",
rating: 5
},
{
id: 2,
name: "Miss. Pooja Kulkarni",
feedback:
"Our extended family planned a Goa holiday from Pune with members of different age groups. Ruturaj Enterprises arranged an Urbania for the complete tour schedule, including the main journey and local travel in Goa. Having one vehicle for the group helped us manage the sightseeing plan and travel timings more conveniently.",
rating: 5
}
];







































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania for Pune to Goa Tour Package",
  "image": "https://ruturajenterprises.com/assets/images/urbania-for-pune-to-goa-tour-package.webp",
  "description": "Urbania for Pune to Goa Tour Package from Ruturaj Enterprises is a spacious group travel solution for families, friends, corporate teams and larger groups planning a comfortable journey from Pune to Goa. Pune to Goa Urbania on Rent, Pune to Goa Urbania Hire and Pune to Goa Urbania Booking are suitable for travellers who want dedicated group transportation for a Goa holiday, sightseeing trip or extended vacation. Urbania Traveller Pune to Goa and Urbania Van Pune to Goa provide convenient options for groups travelling together, while 13 Seater Urbania Pune to Goa, 14 Seater Urbania Pune to Goa, 17 Seater Urbania Pune to Goa and 20 Seater Urbania Pune to Goa allow passengers to select a vehicle according to their group size and travel requirements. Luxury Urbania Pune to Goa is suitable for travellers looking for a more spacious and comfortable option for the longer interstate journey. Urbania for Goa Trip from Pune can be arranged for leisure holidays, beach tours, family vacations and group excursions. Urbania for Goa Family Tour Pune and Urbania for Goa Group Tour Pune are useful for passengers who prefer travelling together in one vehicle. Urbania Rental Pune to Goa and Urbania Outstation Hire Pune to Goa support planned interstate travel, while Urbania Round Trip Pune to Goa is suitable for travellers who want transportation for both the onward and return journey. Urbania Traveller Rental Pune to Goa can be arranged according to the planned itinerary and group size. Pune to Goa Urbania Tour Package and Pune to Goa Urbania Travel Package can accommodate longer holiday schedules, sightseeing plans and multi-day trips. Affordable Urbania Pune to Goa provides a practical group transportation option for travellers looking to manage travel costs while enjoying a dedicated vehicle for their Goa journey.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/urbania-for-pune-to-goa-tour-package"
  }
};





    return (
        <div>


<Helmet>
  <title>
    Urbania for Pune to Goa Tour Package | Luxury 13, 14, 17 & 20 Seater Traveller | +91 9763381382
  </title>

  <meta
    name="description"
    content="Urbania for Pune to Goa Tour Package by Ruturaj Enterprises for family holidays, group tours and round trips with 13, 14, 17 and 20 seater Urbania options."
  />

  <meta
    name="keywords"
    content="Urbania for Pune to Goa Tour Package, Pune to Goa Urbania on Rent, Pune to Goa Urbania Hire, Pune to Goa Urbania Booking, Urbania Traveller Pune to Goa, Urbania Van Pune to Goa, 13 Seater Urbania Pune to Goa, 14 Seater Urbania Pune to Goa, 17 Seater Urbania Pune to Goa, 20 Seater Urbania Pune to Goa, Luxury Urbania Pune to Goa, Urbania for Goa Trip from Pune, Urbania for Goa Family Tour Pune, Urbania for Goa Group Tour Pune, Urbania Rental Pune to Goa, Urbania Outstation Hire Pune to Goa, Urbania Round Trip Pune to Goa, Urbania Traveller Rental Pune to Goa, Pune to Goa Urbania Tour Package, Pune to Goa Urbania Travel Package, Affordable Urbania Pune to Goa, Urbania with Driver Pune to Goa, AC Urbania Pune to Goa, Pune Goa Group Traveller, Pune Goa Family Traveller, Pune to Goa Luxury Traveller, Pune to Goa Outstation Urbania, Pune Goa Round Trip Urbania, Pune to Goa Group Tour Vehicle, Goa Tour from Pune Urbania, Goa Family Trip Urbania Pune, Goa Group Travel Urbania Pune, Urbania Rental with Driver Pune to Goa, Goa Sightseeing Urbania, Pune Goa Holiday Traveller, Pune to Goa Multi Day Urbania, Pune Goa Travel Vehicle"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/112.png' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaforpunetogoa;